// src/components/Footer.jsx
import React, { useRef, useEffect } from "react";
import { motion, useInView } from "framer-motion";
import {
  MapPin,
  Phone,
  Instagram,
  Facebook,
  Mail,
  Clock,
  ArrowRight,
  Navigation,
  Sparkles,
} from "lucide-react";
import { Link } from "react-router-dom";

/* --- WhatsApp Icon (Lucide doesn't have it) --- */
const WhatsAppIcon = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M19.11 17.44c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.14-.42-2.17-1.33-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.42.12-.56.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.02-.22-.53-.45-.46-.61-.47h-.52c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.98 2.63 1.12 2.81.14.18 1.93 2.95 4.67 4.13.65.28 1.16.45 1.56.58.65.21 1.24.18 1.71.11.52-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.32z" />
    <path d="M16 3C9.37 3 4 8.37 4 15c0 2.11.55 4.17 1.6 5.99L4 29l8.22-1.57A11.9 11.9 0 0 0 16 27c6.63 0 12-5.37 12-12S22.63 3 16 3zm0 21.82c-1.85 0-3.67-.5-5.26-1.45l-.38-.22-4.88.93.94-4.76-.25-.4A9.82 9.82 0 1 1 16 24.82z" />
  </svg>
);

/* --- Restaurant Guru Award Badge --- */
const AwardBadge = ({ className = "" }) => {
  useEffect(() => {
    const HREF = "https://awards.infcdn.net/2026/circle_v2.css";
    if (!document.querySelector(`link[href="${HREF}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = HREF;
      document.head.appendChild(link);
    }
  }, []);

  const badgeHTML = `<div id="circle-r-ribbon" onclick="if(event.target.nodeName.toLowerCase() != 'a') {window.open(this.querySelector('.r-ribbon_title').href);return 0;}" class=" rg-award-lang-en_US" style="cursor: pointer; overflow: hidden; position: relative; display: flex; flex-direction: column; padding: 0; max-width: 174px; min-width: 174px; height: 135px; font: 400 10px/normal 'Akrobat Bold', 'Helvetica Neue', 'Arial', sans-serif; align-items: center; text-align: center; color: #000 !important; text-shadow: none; background: url(https://awards.infcdn.net/img/bg.svg) no-repeat; box-sizing: border-box;"> <div class="r-ribbon_ahead " style="transform: rotate(-11deg); position: absolute; z-index: 4; top: -7px; left: 6px; letter-spacing: 0.2px; padding: 0;"> <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="160px" height="160px" viewBox="0 0 160 160" style="width: 160px; height: 160px; margin-top: 0;"> <defs> <path id="heading-arc" d="M 30 80 a 50 50 0 1 1 100 0"></path> </defs> <text class="r-ribbon_ahead-heading" fill="#000" text-anchor="middle" style="font-size: 16px !important; font-family: 'Akrobat Bold', 'Helvetica Neue', 'Arial', sans-serif !important; line-height: 1; text-transform: uppercase !important; alignment-baseline: auto;"> <textPath startOffset="50%" xlink:href="#heading-arc">Recommended</textPath> </text> </svg> </div> <p class="r-ribbon_year" style="color: #000; width: 140px; font: 22px/normal 'Akrobat Black', 'Helvetica Neue', 'Arial', sans-serif !important; font-style: italic !important; transform: rotate(-12deg); position: absolute; top: 41px !important; left: 12px !important; letter-spacing: 0.6px; text-align: center !important; padding: 0 !important; margin: 0 !important;">2026</p> <a href="https://restaurantguru.com/Latino-Bar-Pag" class="r-ribbon_title" target="_blank" style="text-transform: uppercase; color: #fff !important; width: 140px; font-size: 11px !important; line-height: normal !important; font-family: 'Akrobat Bold', 'Helvetica Neue', 'Arial', sans-serif !important; font-style: italic !important; transform: rotate(-12deg); position: absolute; z-index: 5; top: 67px; left: 16px; letter-spacing: 0.4px !important; text-align: center !important; white-space: normal; padding: 0 !important; margin: 0 !important; text-decoration: none !important; border-bottom: none; box-shadow: none; height: 27px; display: flex; align-items: center; justify-content: center;">D10’s Pizza Fantasista</a> <div class="r-ribbon_ahead r-ribbon_ahead-bottom" style="top: auto; bottom: -14px; left: 26px; letter-spacing: 0.3px; transform: rotate(-13deg); height: 100% !important; max-width: 100%; padding: 0; position: absolute !important; z-index: 4;"> <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="120px" height="120px" viewBox="0 0 120 120" style="width: 120px; height: 120px; margin-top: 0;"> <defs> <path id="subheading-arc" d="M 12 60 a 48 48 0 0 0 96 0"></path> </defs> <text class="r-ribbon_ahead-subh" fill="#000" text-anchor="middle" style="font: 12px/1 'Akrobat Regular', 'Helvetica Neue', 'Arial', sans-serif !important; text-transform: uppercase; letter-spacing: normal;"> <textPath startOffset="50%" xlink:href="#subheading-arc"><a href="https://restaurantguru.com" target="_blank" style="font: 12px/1 'Akrobat Regular', 'Helvetica Neue', 'Arial', sans-serif !important; text-transform: uppercase; letter-spacing: 0.3px; text-decoration: none !important; border-bottom: none; box-shadow: none; padding: 0; margin: 0;">Restaurant Guru</a></textPath> </text> </svg> </div></div>`;

  return <div className={className} dangerouslySetInnerHTML={{ __html: badgeHTML }} />;
};

/* --- LINKS / CONTACT --- */
const WHATSAPP_NUMBER_E164 = "385955011065"; // ✅ same number, without + and spaces

const D10 = {
  website: "https://www.d10s.pizza",
  menu: "/menu",
  contact: "/contact",
  reservation: "/reservations", // ✅ matches your router
  about: "/about",
  blog: "/blog",

  instagram: "https://www.instagram.com/d10spizza/",
  facebook: "https://www.facebook.com/d10spizza/",

  addressLine: "Prosika 51A, Pag, Croatia",
  phoneDisplay: "+385 95 501 1065",
  phoneLink: "tel:+385955011065",
  email: "d10spizzafantasista@gmail.com",

  // ✅ WhatsApp (prefill message is optional; keep it simple)
  whatsapp: `https://wa.me/${WHATSAPP_NUMBER_E164}`,

  googleMaps:
    "https://www.google.com/maps/search/?api=1&query=Prosika%2051A%2C%2023250%20Pag%2C%20Croatia",
};

const Footer = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <footer ref={ref} className="bg-[#0F172A] relative overflow-hidden">
      {/* HERO CTA SECTION */}
      <section className="relative py-16 sm:py-20 md:py-28 overflow-hidden">
        {/* Background Effects */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/4 w-[600px] h-[600px] bg-[#0087E6] rounded-full blur-[250px] opacity-20" />
          <div className="absolute bottom-0 right-1/4 w-[420px] h-[420px] bg-[#FFD700] rounded-full blur-[220px] opacity-12" />
        </div>

        {/* Large Background Text */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <span className="font-anton text-[20vw] md:text-[15vw] text-white/[0.02] uppercase whitespace-nowrap">
            D10 FANTASISTA
          </span>
        </div>

        <div className="container mx-auto px-4 sm:px-6 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur mb-6 sm:mb-8">
              <span className="w-2 h-2 bg-[#FFD700] rounded-full animate-pulse" />
              <span className="text-white/80 text-[10px] sm:text-xs font-bold uppercase tracking-[0.2em]">
                You are welcome
              </span>
            </div>

            {/* Main Headline */}
            <h2
              className="font-anton text-white uppercase leading-[0.85] mb-6 sm:mb-8"
              style={{ fontSize: "clamp(2.4rem, 9.5vw, 6.8rem)" }}
            >
              Ready For <br />
              <span className="text-[#FFD700]">Kickoff?</span>
            </h2>

            <p className="font-manrope text-white/60 text-base sm:text-lg max-w-2xl mx-auto mb-8 sm:mb-10 leading-relaxed">
              Come for the pizza, stay for the vibe. Pag, beach, good music,
              loud laughs, and a table that feels like your spot.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
              <Link
                to={D10.reservation}
                className="w-full sm:w-auto px-8 py-4 bg-[#0087E6] text-white font-anton text-lg sm:text-xl uppercase rounded-xl hover:bg-[#0070c0] transition-all duration-300 flex items-center justify-center gap-3 shadow-lg shadow-[#0087E6]/30 group"
              >
                Reserve a Table
                <ArrowRight
                  size={20}
                  className="group-hover:translate-x-1 transition-transform"
                />
              </Link>

              <Link
                to={D10.menu}
                className="w-full sm:w-auto px-8 py-4 bg-white/10 border border-white/20 text-white font-anton text-lg sm:text-xl uppercase rounded-xl hover:bg-white/20 transition-all duration-300 backdrop-blur"
              >
                View Menu
              </Link>
            </div>

            {/* Micro note */}
            <div className="mt-5 sm:mt-6 text-white/40 text-xs sm:text-sm font-bold uppercase tracking-widest flex items-center justify-center gap-2">
              <Sparkles size={14} className="text-[#FFD700]" />
              Walk-ins welcome, reservations recommended
            </div>
          </motion.div>
        </div>
      </section>

      {/* SOCIAL STRIP */}
      <section className="bg-[#0087E6] py-8 sm:py-10">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Social Links */}
            <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
              <span className="text-white/80 text-xs sm:text-sm font-manrope uppercase tracking-wider">
                Follow the vibe
              </span>

              <div className="flex items-center gap-3">
                <a
                  href={D10.instagram}
                  target="_blank"
                  rel="noreferrer"
                  className="group flex items-center gap-2 px-4 sm:px-5 py-2.5 sm:py-3 bg-white/10 hover:bg-white rounded-full transition-all duration-300"
                >
                  <Instagram
                    size={20}
                    className="text-white group-hover:text-[#0087E6] transition-colors"
                  />
                  <span className="text-white group-hover:text-[#0087E6] font-bold text-sm transition-colors">
                    @d10spizza
                  </span>
                </a>

                <a
                  href={D10.facebook}
                  target="_blank"
                  rel="noreferrer"
                  className="p-2.5 sm:p-3 bg-white/10 hover:bg-white rounded-full transition-all duration-300 group"
                  aria-label="D10 on Facebook"
                >
                  <Facebook
                    size={20}
                    className="text-white group-hover:text-[#0087E6] transition-colors"
                  />
                </a>

                {/* ✅ WhatsApp (new) */}
                <a
                  href={D10.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  className="p-2.5 sm:p-3 bg-white/10 hover:bg-white rounded-full transition-all duration-300 group"
                  aria-label="D10 on WhatsApp"
                >
                  <WhatsAppIcon
                    size={20}
                    className="text-white group-hover:text-[#0087E6] transition-colors"
                  />
                </a>
              </div>
            </div>

            {/* Quick Contact */}
            <div className="flex items-center gap-4 sm:gap-6">
              <a
                href={D10.phoneLink}
                className="flex items-center gap-2 text-white hover:text-[#FFD700] transition-colors"
              >
                <Phone size={16} />
                <span className="font-manrope text-sm sm:text-base">
                  {D10.phoneDisplay}
                </span>
              </a>

              <div className="hidden sm:block w-px h-6 bg-white/20" />

              <a
                href={D10.googleMaps}
                target="_blank"
                rel="noreferrer"
                className="hidden sm:flex items-center gap-2 text-white hover:text-[#FFD700] transition-colors"
              >
                <Navigation size={16} />
                <span className="font-manrope text-sm">Get directions</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* MAIN FOOTER CONTENT */}
      <section className="bg-[#0a1222] py-12 sm:py-16">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
            {/* Brand Column */}
            <div className="sm:col-span-2 lg:col-span-1">
              <img
                src="/d10logo.svg"
                alt="D10 Pizza Fantasista"
                className="h-10 sm:h-12 w-auto mb-4 sm:mb-5"
              />
              <p className="font-manrope text-white/55 text-sm leading-relaxed mb-5">
                D10 is a beachside pizzeria with a football soul. Neapolitan
                craft, local energy, and a place that feels like a proper night
                out, not just a quick meal.
              </p>

              {/* Location Badge */}
              <a
                href={D10.googleMaps}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 rounded-lg border border-white/10 hover:border-[#0087E6]/50 hover:bg-[#0087E6]/10 transition-all group"
              >
                <MapPin size={14} className="text-[#FFD700]" />
                <span className="text-white/75 text-xs sm:text-sm font-manrope group-hover:text-white transition-colors">
                  {D10.addressLine}
                </span>
              </a>

              {/* ✅ Restaurant Guru Award Badge */}
              <div className="mt-6 flex justify-center sm:justify-start">
                <AwardBadge />
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-anton text-white text-lg sm:text-xl uppercase mb-4 sm:mb-5">
                Explore
              </h4>
              <nav className="flex flex-col gap-2 sm:gap-3">
                {[
                  { label: "Menu", path: D10.menu },
                  { label: "Reservation", path: D10.reservation },
                  { label: "Our Story", path: D10.about },
                  { label: "Journal", path: D10.blog },
                  { label: "Contact", path: D10.contact },
                ].map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className="text-white/55 hover:text-[#0087E6] font-manrope text-sm sm:text-base transition-colors flex items-center gap-2 group"
                  >
                    <span className="w-0 group-hover:w-2 h-0.5 bg-[#0087E6] transition-all duration-300" />
                    {link.label}
                  </Link>
                ))}
              </nav>
            </div>

            {/* Hours */}
            <div>
              <h4 className="font-anton text-white text-lg sm:text-xl uppercase mb-4 sm:mb-5">
                Hours
              </h4>
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-start gap-3">
                  <Clock
                    size={16}
                    className="text-[#FFD700] mt-0.5 flex-shrink-0"
                  />
                  <div>
                    <p className="text-white/85 text-sm sm:text-base font-manrope">
                      10:00 – 24:00
                    </p>
                    <p className="text-white/45 text-xs sm:text-sm">
                      All year
                    </p>
                  </div>
                </div>

                <div className="p-3 bg-[#FFD700]/10 rounded-lg border border-[#FFD700]/20">
                  <p className="text-[#FFD700] text-xs sm:text-sm font-bold flex items-center gap-2">
                    <Instagram size={14} />
                    Daily updates on @d10spizza
                  </p>
                </div>

                <div className="text-white/45 text-xs sm:text-sm leading-relaxed">
                  For bigger groups or late arrivals, just message us. We’re
                  flexible when we can be.
                </div>
              </div>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-anton text-white text-lg sm:text-xl uppercase mb-4 sm:mb-5">
                Contact
              </h4>
              <div className="space-y-3 sm:space-y-4">
                <a
                  href={D10.phoneLink}
                  className="flex items-center gap-3 text-white/75 hover:text-white transition-colors group"
                >
                  <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/5 group-hover:bg-[#0087E6]/20 flex items-center justify-center transition-colors">
                    <Phone size={16} className="text-[#0087E6]" />
                  </div>
                  <span className="font-manrope text-sm sm:text-base">
                    {D10.phoneDisplay}
                  </span>
                </a>

                {/* ✅ WhatsApp quick link (new, minimal) */}
                <a
                  href={D10.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 text-white/75 hover:text-white transition-colors group"
                >
                  <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/5 group-hover:bg-[#0087E6]/20 flex items-center justify-center transition-colors">
                    <WhatsAppIcon size={16} className="text-[#0087E6]" />
                  </div>
                  <span className="font-manrope text-sm sm:text-base">
                    WhatsApp us
                  </span>
                </a>

                <a
                  href={`mailto:${D10.email}`}
                  className="flex items-center gap-3 text-white/75 hover:text-white transition-colors group"
                >
                  <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/5 group-hover:bg-[#0087E6]/20 flex items-center justify-center transition-colors">
                    <Mail size={16} className="text-[#0087E6]" />
                  </div>
                  <span className="font-manrope text-xs sm:text-sm break-all">
                    {D10.email}
                  </span>
                </a>

                {/* Social Icons */}
                <div className="flex items-center gap-2 pt-2">
                  <a
                    href={D10.instagram}
                    target="_blank"
                    rel="noreferrer"
                    className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/5 hover:bg-[#0087E6] flex items-center justify-center transition-all group"
                    aria-label="D10 on Instagram"
                  >
                    <Instagram
                      size={18}
                      className="text-white/75 group-hover:text-white transition-colors"
                    />
                  </a>

                  <a
                    href={D10.facebook}
                    target="_blank"
                    rel="noreferrer"
                    className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/5 hover:bg-[#0087E6] flex items-center justify-center transition-all group"
                    aria-label="D10 on Facebook"
                  >
                    <Facebook
                      size={18}
                      className="text-white/75 group-hover:text-white transition-colors"
                    />
                  </a>

                  {/* ✅ WhatsApp icon (new) */}
                  <a
                    href={D10.whatsapp}
                    target="_blank"
                    rel="noreferrer"
                    className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/5 hover:bg-[#0087E6] flex items-center justify-center transition-all group"
                    aria-label="D10 on WhatsApp"
                  >
                    <WhatsAppIcon
                      size={18}
                      className="text-white/75 group-hover:text-white transition-colors"
                    />
                  </a>
                </div>

                <a
                  href={D10.googleMaps}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-white/60 hover:text-[#FFD700] transition-colors text-sm font-bold pt-1"
                >
                  <Navigation size={16} />
                  Get directions
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BOTTOM BAR */}
      <section className="bg-[#070d17] py-5 sm:py-6">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
            <p className="text-white/30 text-xs sm:text-sm font-manrope text-center sm:text-left">
              © {new Date().getFullYear()} D10 Pizza Fantasista. All rights
              reserved.
            </p>
            <div className="flex items-center gap-2">
              <span className="text-white/20 text-xs">🍕</span>
              <p className="font-serif italic text-white/45 text-xs sm:text-sm">
                Prosika • Pag Island • Croatia
              </p>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;